import { Box, Skeleton } from "@mui/material";
import { TableColumn } from "@vilocnv/allsetra-core";
import { formatTimeStamp } from "app/data/helpers";
import {
  getTagPositionLocationLabel,
  isTagPositionLocationPending
} from "app/data/helpers/ReportHelpers/tagPositionHelpers";
import { Check, Cross } from "assets/icons";

export const TAG_POSITION_TABLE_COLUMNS = (
  translator: any
): TableColumn<any>[] => [
  {
    name: translator("tableHeading.objectName", {
      ns: "tableHeadingsTranslation"
    }),
    selector: (row: any) => row?.name || "N/A",
    wrap: true
  },
  {
    name: translator("tableHeading.id", {
      ns: "tableHeadingsTranslation"
    }),
    selector: (row: any) => row?.aNumber || "N/A"
  },
  {
    name: translator("tableHeading.positions", {
      ns: "tableHeadingsTranslation"
    }),
    selector: (row: any) => row?.positionCount ?? 0
  }
];

export const TAG_POSITION_DATE_COLUMNS = (
  translator: any
): TableColumn<any>[] => [
  {
    name: translator("tableHeading.time", { ns: "tableHeadingsTranslation" }),
    selector: (row: any) => row.label,
    grow: 1
  },
  {
    name: translator("tableHeading.location", {
      ns: "tableHeadingsTranslation"
    }),
    grow: 2,
    wrap: true,
    style: {
      whiteSpace: "normal"
    }
  },
  {
    name: translator("tableHeading.accuracy", {
      ns: "tableHeadingsTranslation"
    }),
    grow: 1
  },
  {
    name: translator("tableHeading.accurate", {
      ns: "tableHeadingsTranslation"
    }),
    grow: 1
  },
  {
    name: "LAT LONG",
    grow: 1
  }
];

export const TAG_POSITION_INNER_TABLE_COLUMNS = (
  resolvedAddresses: Array<{
    latitude: number;
    longitude: number;
    address: string;
  }> = []
): TableColumn<any>[] => [
  {
    selector: (row: any) => formatTimeStamp(row.date),
    grow: 1
  },
  {
    cell: (row: any) => {
      const locationLabel = getTagPositionLocationLabel(
        row,
        resolvedAddresses,
        ""
      );

      if (locationLabel) {
        return (
          <Box
            component="span"
            sx={{
              display: "block",
              width: "100%",
              whiteSpace: "normal",
              overflowWrap: "break-word",
              wordBreak: "break-word",
              lineHeight: 1.35
            }}
          >
            {locationLabel}
          </Box>
        );
      }

      if (isTagPositionLocationPending(row, resolvedAddresses)) {
        return <Skeleton variant="text" width={100} height={18} />;
      }

      return "";
    },
    wrap: true,
    grow: 2,
    style: {
      whiteSpace: "normal",
      overflow: "hidden"
    }
  },
  {
    selector: (row: any) => `${row.accuracy} m`,
    grow: 1
  },
  {
    cell: (row: any) => (row.isAccurate ? <Check /> : <Cross />),
    grow: 1
  },
  {
    cell: (row: any) => `${row.latitude} ${row.longitude}`,
    grow: 1
  }
];

export const TAG_POSITION_HEADERS = [
  { label: "Object Name", key: "ObjectName" },
  { label: "ID", key: "ID" },
  { label: "Time", key: "Time" },
  { label: "Location", key: "Location" },
  { label: "Accuracy", key: "Accuracy" },
  { label: "Accurate", key: "Accurate" },
  { label: "LAT LONG", key: "LatLong" }
];
